import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import mutations from './mutations'
import store from '@/utils/storage'

Vue.use(Vuex)

const vueStore = new Vuex.Store({
  state: {
    userInfo: store.get('userInfo') || {},
    customcmd: store.get('customcmd') || { user: {}, domains: [] },
    companyId: store.get('companyId') || '',
    token: store.get('token') || '',
    showHistory: store.get('showHistory') || false,
    historyList: store.get('historyList') || [],
    firstEnter: true,
    appScroll: false,
    isMobile: false
  },
  getters,
  mutations
})

export default vueStore



// WEBPACK FOOTER //
// ./src/store/index.js